import React, { useState, useEffect, useRef } from "react";
import useAxios from 'axios-hooks';
import TextField from "../../../Forms/TextField";
import Select from "react-select";
import { FixedSizeList as List } from "react-window";

const CustomMenuList = ({ children, ...props }) => {
    const height = 35;
    const itemCount = children.length;
    const totalHeight = Math.min(300, itemCount * height);

    return (
        <List height={totalHeight} itemCount={itemCount} itemSize={height} width="100%">
            {({ index, style }) => (
                <div
                    style={{
                        ...style,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        padding: "0 8px",
                        boxSizing: "border-box",
                    }}
                    title={children[index]?.props?.children}
                >
                    {children[index]}
                </div>
            )}
        </List>
    );
};

const EmailImages = ({ values, setFieldValue }) => {
    const [logoCobrandCopy, setLogoCobrandCopy] = useState(true);

    const [{ data: cobrands, loading: loadingCobrands }] = useAxios('/internal/cobrands');
    const cobrandsOptions = cobrands && cobrands.map(u => ({ value: u.cobrandId, label: u.name }));

    const [{ data: cobrandSettings, loading: loadingCobrandSettings }, fetchCobrandSettings] = useAxios(
        { url: '/internal/cobrand/launcher', method: 'GET' },
        { manual: true }
    );

    const handleCobrandChange = async (option, setFieldValue) => {
        setLogoCobrandCopy(option.value);
        const selectedCobrandId = option.value;

        const result = await fetchCobrandSettings({
            url: `/internal/cobrand/launcher/${selectedCobrandId}`,
        });

        if (!result.error) {
            const settings = result.data;
            setFieldValue('emlHeaderWaveURL', settings.emlHeaderWaveURL);
            setFieldValue("emlFooterWaveURL", settings.emlFooterWaveURL);


        } else {
            setShowError(true);
        }
    };

    return (
        <div className="panel panel-default">
            <div className="panel-heading panel-heading-cobrand"><div className='panel-h'>Email Images</div>
                <div className="cobrand-select">
                    <Select
                        components={{ MenuList: CustomMenuList }}
                        options={cobrandsOptions}
                        placeholder="Copy from Cobrand"
                        name="clientId"
                        value={cobrandsOptions?.find(
                            (option) => option.value === logoCobrandCopy
                        )}
                        onChange={(option) => {
                            handleCobrandChange(option, setFieldValue);
                        }}
                        isSearchable
                        styles={{
                            menuList: (base) => ({
                                ...base,
                                maxHeight: "300px",
                                overflowY: "auto",
                            }),
                            container: (base) => ({
                                ...base,
                                width: 200,
                            }),
                            control: (base) => ({
                                ...base,
                                border: "1px solid #aaaaaa",
                            }),
                        }}
                    />
                </div>
            </div>
            <div className="panel-body">
                <fieldset>
                    <div className="form-inline">
                        <TextField
                            label="Email Header"
                            name="emlHeaderWaveURL"
                            className="bigger-input"
                            value={values.emlHeaderWaveURL}
                            onChange={(e, val) => setFieldValue('emlHeaderWaveURL', val || '')}
                            placeholder="CDN URL slug"
                            required
                        /> </div>
                    <div className="form-inline">
                        <TextField
                            label="Email Footer"
                            name="emlFooterWaveURL"
                            className="bigger-input"
                            value={values.emlFooterWaveURL}
                            onChange={(e, val) => setFieldValue('emlFooterWaveURL', val || '')}
                            placeholder="CDN URL slug"
                            required
                        /> </div>
                </fieldset>
            </div>
        </div>
    );
};

export default EmailImages;
